import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useFund } from '../context/FundContext';
import { useAuth } from '../context/AuthContext';

const TITLES = {
  '/dashboard': 'Dashboard',
  '/nav-pack': 'NAV Pack',
  '/accounting': 'Accounting',
  '/portfolio': 'Portfolio',
  '/investor': 'Investor',
  '/performance': 'Performance',
  '/gain-loss': 'Gain / Loss',
  '/data-query': 'Data Query',
};

export default function Header({ onMenu }) {
  const { pathname } = useLocation();
  const { fund } = useFund();
  const { user, logout } = useAuth();
  const title = TITLES[pathname] || 'Dashboard';

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Close the profile menu on an outside click or Escape.
  useEffect(() => {
    if (!menuOpen) return undefined;
    function onDocClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    }
    function onKey(e) {
      if (e.key === 'Escape') setMenuOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [menuOpen]);

  const name = user?.name || user?.username || 'Account';
  const initial = (name[0] || 'A').toUpperCase();

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button type="button" className="menu-btn" onClick={onMenu} aria-label="Toggle menu">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="2" strokeLinecap="round">
            <path d="M3 6h18M3 12h18M3 18h18" />
          </svg>
        </button>
        <div className="topbar-title">{title}</div>
        {fund && <div className="topbar-fund">{fund}</div>}
      </div>
      <div className="topbar-right">
        <div className="profile" ref={menuRef}>
          <button
            type="button"
            className="avatar"
            title={name}
            onClick={() => setMenuOpen((v) => !v)}
            aria-haspopup="menu"
            aria-expanded={menuOpen}
          >
            {initial}
          </button>

          {menuOpen && (
            <div className="profile-menu" role="menu">
              <div className="profile-info">
                <div className="profile-name">{name}</div>
                {user?.username && <div className="profile-sub">@{user.username}</div>}
              </div>
              <button
                type="button"
                className="profile-item"
                role="menuitem"
                onClick={() => {
                  setMenuOpen(false);
                  logout();
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <path d="M16 17l5-5-5-5" /><path d="M21 12H9" />
                </svg>
                Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
